import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime-corejs3/helpers/objectWithoutPropertiesLoose";
var _excluded = ["className", "style", "type", "value", "defaultValue", "placeholder", "clearable", "disabled", "size", "rows", "autoWidth", "fluid", "width", "stackClearIcon", "frozenOnInput", "readonly", "inline", "waveDisabled", "resize", "flat", "showCount", "maxlength", "ev-click", "ev-mounseenter", "ev-mouseleave"];
import _flatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/flat";
import { createElementVNode as _$ce, className as _$cn, createUnknownComponentVNode as _$cc, noop as _$no, createVNode as _$cv, createTextVNode as _$ct } from 'intact-vue';
import { Icon } from '../icon';
import { addStyle, isTextBlock, getRestProps, stopPropagation } from '../utils';
import { makeStyles } from './styles';
import { noop, isNullOrUndefined, isStringOrNumber } from 'intact-shared';
import { Wave } from '../wave';
import { context as ErrorContext } from '../form/useError';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj,
    _$cn2,
    children,
    _this = this,
    _$cn5,
    _children;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _$blocks = {};
  var __$blocks = {};
  var _this$get = this.get(),
    className = _this$get.className,
    style = _this$get.style,
    type = _this$get.type,
    value = _this$get.value,
    defaultValue = _this$get.defaultValue,
    placeholder = _this$get.placeholder,
    clearable = _this$get.clearable,
    disabled = _this$get.disabled,
    size = _this$get.size,
    rows = _this$get.rows,
    autoWidth = _this$get.autoWidth,
    fluid = _this$get.fluid,
    width = _this$get.width,
    stackClearIcon = _this$get.stackClearIcon,
    frozenOnInput = _this$get.frozenOnInput,
    readonly = _this$get.readonly,
    inline = _this$get.inline,
    waveDisabled = _this$get.waveDisabled,
    resize = _this$get.resize,
    flat = _flatInstanceProperty(_this$get),
    showCount = _this$get.showCount,
    maxlength = _this$get.maxlength,
    click = _this$get['ev-click'],
    mouseenter = _this$get['ev-mounseenter'],
    mouseleave = _this$get['ev-mouseleave'],
    rest = _objectWithoutPropertiesLoose(_this$get, _excluded);
  var _this$frozen = this.frozen,
    inputing = _this$frozen.inputing.value,
    originalValue = _this$frozen.originalValue.value,
    startInput = _this$frozen.startInput,
    onInput = _this$frozen.onInput,
    endInput = _this$frozen.endInput;
  var _this$focusHook = this.focusHook,
    isFocus = _this$focusHook.isFocus,
    focusInputOnClick = _this$focusHook.focusInputOnClick;
  var isNotAutoRows = isStringOrNumber(rows) && rows !== 'auto';
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-input"] = true, _classNameObj[k + "-" + size] = size !== 'default', _classNameObj[k + "-group"] = $blocks.prepend || $blocks.append, _classNameObj[k + "-disabled"] = disabled, _classNameObj[k + "-clearable"] = clearable, _classNameObj[k + "-auto-width"] = autoWidth, _classNameObj[k + "-fluid"] = fluid, _classNameObj[k + "-stack-clear"] = stackClearIcon, _classNameObj[k + "-inline"] = inline, _classNameObj[k + "-flat"] = flat, _classNameObj[k + "-type-textarea"] = type === 'textarea', _classNameObj[k + "-focus"] = isFocus.value, _classNameObj[k + "-resize-" + resize] = type === 'textarea' && isNotAutoRows, _classNameObj[k + "-resize-none"] = type === 'textarea' && !isNotAutoRows, _classNameObj[className] = className, _classNameObj[makeStyles(k)] = true, _classNameObj);
  var _this$showPassword = this.showPassword,
    isShowPassword = _this$showPassword.isShow,
    toggleShowPassword = _this$showPassword.toggleShow,
    showPasswordType = _this$showPassword.type,
    showPasswordIcon = _this$showPassword.showIcon;
  var _this$autoWidth = this.autoWidth,
    fakeRef = _this$autoWidth.fakeRef,
    fakeWidth = _this$autoWidth.width.value;
  var height = this.autoRows;
  var inputValue = frozenOnInput && inputing ? originalValue : value;
  var hasInputValue = !isNullOrUndefined(inputValue);
  var hasValue = hasInputValue && inputValue !== '';
  var inputProps = _extends({}, getRestProps(this, rest), {
    'ev-focus': startInput,
    'ev-blur': endInput,
    'ev-input': onInput,
    defaultValue: defaultValue,
    readOnly: readonly,
    placeholder: placeholder,
    disabled: disabled,
    maxLength: maxlength,
    ref: this.inputRef,
    style: autoWidth && fakeWidth ? {
      width: fakeWidth + 'px'
    } : undefined
  });
  // if we pass value to input element, the input is controlled and the
  // defaultValue does not work
  if (hasInputValue) {
    inputProps.value = inputValue;
  }
  return _$ce(2, 'div', [$blocks.prepend ? (children = $blocks.prepend(noop), _$ce(2, 'div', children, 0, _$cn((_$cn2 = {}, _$cn2[k + "-input-prepend"] = true, _$cn2[k + "-input-padding"] = isTextBlock(children), _$cn2)))) : void 0, _$cc(ErrorContext.Consumer, {
    'defaultValue': false,
    'children': function children(isInvalid) {
      var _$cn3, _$cn4;
      return _$cc(Wave, {
        'disabled': waveDisabled || disabled || isInvalid,
        'inset': '-2px',
        'children': _$ce(2, 'div', [$blocks.prefix ? _$ce(2, 'div', (_$blocks['prefix'] = function ($super) {
          return null;
        }, __$blocks['prefix'] = function ($super, data) {
          var block = $blocks['prefix'];
          var callBlock = function callBlock() {
            return _$blocks['prefix'].call($this, $super, data);
          };
          return block ? block.call($this, callBlock, data) : callBlock();
        }, __$blocks['prefix'](_$no)), 0, _$cn(k + "-input-prefix")) : undefined, type !== 'textarea' ? _$cv('input', _extends({}, inputProps, {
          'className': _$cn(k + "-input-inner"),
          'type': showPasswordType.value
        })) : _$cv('textarea', _extends({}, inputProps, {
          'className': _$cn(k + "-input-inner " + k + "-textarea"),
          'rows': isNotAutoRows ? rows : 1,
          'style': height.value ? addStyle(inputProps.style, {
            height: height.value + 'px'
          }) : inputProps.style
        })), $blocks.suffix || clearable && !disabled || showPasswordIcon.value || showCount ? _$ce(2, 'div', [showPasswordIcon.value ? [_$cc(Icon, {
          'hoverable': true,
          'className': _$cn((_$cn3 = {}, _$cn3[k + "-input-show-password"] = true, _$cn3[k + "-icon-hidden"] = !isShowPassword.value, _$cn3[k + "-icon-visible"] = isShowPassword.value, _$cn3)),
          'ev-click': toggleShowPassword
        }), ' '] : undefined, clearable && !disabled ? _$cc(Icon, {
          'className': _$cn((_$cn4 = {}, _$cn4[k + "-input-clear " + k + "-icon-error-fill"] = true, _$cn4[k + "-input-show"] = hasValue, _$cn4)),
          'ev-click': _this.clear,
          'hoverable': true
        }) : undefined, ' ', showCount ? _$ce(2, 'span', [hasValue ? value.length : 0, maxlength ? _$ce(2, 'span', [_$ct(' / '), maxlength], 0) : undefined], 0, _$cn(k + "-input-count")) : undefined, (_$blocks['suffix'] = function ($super) {
          return null;
        }, __$blocks['suffix'] = function ($super, data) {
          var block = $blocks['suffix'];
          var callBlock = function callBlock() {
            return _$blocks['suffix'].call($this, $super, data);
          };
          return block ? block.call($this, callBlock, data) : callBlock();
        }, __$blocks['suffix'](_$no))], 0, _$cn(k + "-input-suffix"), {
          'ev-click': stopPropagation
        }) : undefined, autoWidth ? _$ce(2, 'div', _$ce(2, 'span', !hasValue ? hasInputValue || !defaultValue ? placeholder : defaultValue : inputValue, 0, null, null, null, fakeRef), 2, _$cn(k + "-input-fake")) : undefined], 0, _$cn(k + "-input-wrapper"), {
          'ev-click': focusInputOnClick
        })
      });
    }
  }), $blocks.append ? (_children = $blocks.append(noop), _$ce(2, 'div', _children, 0, _$cn((_$cn5 = {}, _$cn5[k + "-input-append"] = true, _$cn5[k + "-input-padding"] = isTextBlock(_children), _$cn5)))) : void 0], 0, _$cn(classNameObj), {
    'style': width != null ? addStyle(style, {
      width: width + "px"
    }) : style,
    'ev-click': click,
    'ev-mouseenter': mouseenter,
    'ev-mouseleave': mouseleave
  });
}
;